import React, { Suspense } from "react"
import { Spinner, Center } from "@chakra-ui/react"
import HTMLText from "../text/HTMLText"

const RichTextEditor = React.lazy(
  () => import("./RichTextEditor" /* webpackChunkName: "RichTextEditor" */)
)

const RichTextEditorLazy = (props: any) => {
  return (
    <Suspense
      // View mode already has saved HTML. Rendering it while the editor module
      // loads preserves layout (and scroll targets) instead of collapsing to a spinner.
      fallback={
        props.mode !== "edit" ? (
          <HTMLText html={props.value || ""} />
        ) : (
          <Center>
            <Spinner />
          </Center>
        )
      }
    >
      <RichTextEditor {...props} />
    </Suspense>
  )
}

export default RichTextEditorLazy
